var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSebi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4971_3709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C4.26149 0 0 4.26149 0 9.5C0 14.7385 4.26149 19 9.5 19C14.7385 19 19 14.7385 19 9.5C19 4.26149 14.7385 0 9.5 0Z",
    fill: "#C8CCD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1061 12.5427L14.252 7.397C14.5615 7.08737 14.5615 6.58712 14.252 6.27763C13.9424 5.968 13.4421 5.968 13.1326 6.27763L8.54642 10.8637L6.53323 8.8505C6.2236 8.54087 5.72335 8.54087 5.41386 8.8505C5.10423 9.15999 5.10423 9.66039 5.41386 9.96987L7.98673 12.5427C8.14111 12.6971 8.34377 12.7748 8.54642 12.7748C8.74907 12.7748 8.95172 12.6971 9.1061 12.5427Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4971_3709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSebi);
export default __webpack_public_path__ + "static/media/sebi.f9e2b6ed4cdc412c396fa65972c3c8d9.svg";
export { ForwardRef as ReactComponent };